import * as React from "react";
import { RxDragHandleDots2 } from "react-icons/rx";
import { CSSProperties } from "styled-components";

export interface IRndCloseProps {
  onClose: () => void;
}

export const dragHandleStyles: CSSProperties = {
  width: "100%",
  position: "relative",
  cursor: "move",
  height: "18px",
};
export default function RndClose({ onClose }: IRndCloseProps) {
  return (
    <div className="relative flex justify-end items-center">
      <span className="dragHandlePdf" style={dragHandleStyles}></span>
      <div
        onClick={onClose}
        className="  hover:text-white cursor-auto select-none text-textSecondary"
      >
        <i className="bi text-2xl cursor-pointer text-inherit bi-dash-lg"></i>
      </div>
      <div className="absolute top-2/4 pointer-events-none cursor-pointer left-2/4 -translate-x-2/4 -translate-y-2/4">
        <RxDragHandleDots2 className="text-secondary rotate-[90deg]  pointer-events-none" />
      </div>
    </div>
  );
}
